export default class PesquisaRecursoJson {
  constructor(
    tipoVisualizacao, agrupador, tiposRecursoSelected, situacoesSelected, tagsSelected, colaboradoresSelected, statusSelected,
    FiltrarResponsavel, FiltrarInteressado
  ) {
    this.tipoVisualizacao = tipoVisualizacao || 'lista';
    this.agrupador = agrupador || 'situacao';
    this.tiposRecursoSelected = tiposRecursoSelected || [];
    this.situacoesSelected = situacoesSelected || [];
    this.tagsSelected = tagsSelected || [];
    this.colaboradoresSelected = colaboradoresSelected || [];
    this.statusSelected = statusSelected || [];
    this.FiltrarResponsavel = FiltrarResponsavel || null;
    this.FiltrarInteressado = FiltrarInteressado || null;
  }
}